import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    REQUEST_MASTER_COUPON,
    REQUEST_CREATE_MASTER_COUPON,
    REQUEST_UPDATE_MASTER_COUPON,
    SET_MASTER_COUPON,
    SUCCESS_CREATE_MASTER_COUPON,
    SUCCESS_UPDATE_MASTER_COUPON,
    ERROR_GET_MASTER_COUPON,
    ERROR_CREATE_MASTER_COUPON,
    ERROR_UPDATE_MASTER_COUPON,
} from "./couponActionType"

function* requestMasterCoupon(action: Record<string, any>): any {
    try {
        const result: any = yield call(getCouponMaster);
        yield put({ type: SET_MASTER_COUPON, payload: result.data });
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_GET_MASTER_COUPON, payload: message });
    }
}

function* requestUpdateMasterCoupon(action: Record<string, any>): any {
    try {
        const result = yield call(
            updateMasterCoupon,
            action.data.payload,
            action.data._id
        )
        yield put({
            type: SUCCESS_UPDATE_MASTER_COUPON,
            payload: result.data,
        });
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_UPDATE_MASTER_COUPON, payload: message });
    }
}

function* requestCreateMasterCoupon(action: Record<string, any>): any {
    try {
        const result = yield call(createMasterCoupon, action.payload);
        yield put({
            type: SUCCESS_CREATE_MASTER_COUPON,
            payload: result.data,
        });
        // update relevant category as well
    } catch (error: any) {
        console.log(error);
        let message =
            "Something went wrong, please try again after some time or Refresh the Page.";
        if (get(error, "response.status") === 500) {
            message = "Something happened wrong try again after sometime.";
        } else if (get(error, "response.status") === 422) {
            message = error.response.data.message || "please provide valid contain";
        } else if (get(error, "response.status") === 415) {
            message = error.response.data.message;
        }
        yield put({ type: ERROR_CREATE_MASTER_COUPON, payload: message });
    }
}


export function getCouponMaster() {
    return axios({
        method: "GET",
        url: `${process.env.REACT_APP_BASE_URL}/stripe/coupons`,
        withCredentials: true,
    });
}

export function updateMasterCoupon(payload: Record<string, any>, _id: string) {
    return axios({
        method: "patch",
        url: `${process.env.REACT_APP_BASE_URL}/stripe/coupons/${_id}`,
        data: payload,
        withCredentials: true,
    });
}

export function createMasterCoupon(payload: Record<string, any>) {
    return axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/stripe/coupons/`,
        data: payload,
        withCredentials: true,
    });
}


const couponMasterSaga = function* () {
    yield all([
        takeLatest(REQUEST_MASTER_COUPON, requestMasterCoupon),
        takeLatest(REQUEST_UPDATE_MASTER_COUPON, requestUpdateMasterCoupon),
        takeLatest(REQUEST_CREATE_MASTER_COUPON, requestCreateMasterCoupon),

    ])
}

export default couponMasterSaga;